import { Smartphone, Bell } from "lucide-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { trackFunnel } from "@/lib/analytics";
import { usePlatformConfig } from "@/lib/config";

export const Route = createFileRoute("/onboarding/enable")({
  component: EnableStep,
});

function EnableStep() {
  const navigate = useNavigate();
  const { platformName } = usePlatformConfig();

  return (
    <div className="flex flex-1 flex-col">
      <h1 className="font-display text-3xl font-bold">Enable notifications</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Add {platformName} to your home screen and allow push so we can reach you when SMS is
        delayed.
      </p>

      <div className="mt-6 space-y-3">
        <div className="rounded-lg border border-border p-4">
          <div className="flex gap-3">
            <Bell className="h-5 w-5 text-primary" />
            <div>
              <p className="text-sm font-bold">Push notifications</p>
              <p className="mt-1 text-xs text-muted-foreground">
                Allow notifications so we can reach you on this device. You can change this anytime.
              </p>
              <Button
                size="sm"
                className="mt-3"
                onClick={async () => {
                  if ("Notification" in window) {
                    await Notification.requestPermission();
                  }
                  toast.message("Push preference saved");
                }}
              >
                Enable push
              </Button>
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-border p-4">
          <div className="flex gap-3">
            <Smartphone className="h-5 w-5 text-primary" />
            <div>
              <p className="text-sm font-bold">Add to home screen</p>
              <p className="mt-1 text-xs text-muted-foreground">
                Android: browser menu → Install app / Add to Home screen. iOS Safari: Share → Add to
                Home Screen.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-auto space-y-2 pt-8">
        <Button
          className="w-full"
          onClick={() => {
            trackFunnel("step_completed", "enable");
            void navigate({ to: "/onboarding/done" });
          }}
        >
          Continue
        </Button>
        <Button
          variant="outline"
          className="w-full"
          onClick={() => void navigate({ to: "/onboarding/contacts" })}
        >
          Back
        </Button>
      </div>
    </div>
  );
}
